export var ModuleLayoutStyle;
(function (ModuleLayoutStyle) {
    ModuleLayoutStyle["Orange"] = "Orange";
    ModuleLayoutStyle["Tomato"] = "Tomato";
    ModuleLayoutStyle["Flower"] = "Flower";
})(ModuleLayoutStyle || (ModuleLayoutStyle = {}));
export var LinkTargetType;
(function (LinkTargetType) {
    LinkTargetType["Self"] = "_self";
    LinkTargetType["Blank"] = "_blank";
})(LinkTargetType || (LinkTargetType = {}));
